export default "__VITE_ASSET__5acd26e8__"